/* Klarta US — Help center (/pages/support). Vanilla, no dependency, progressive.
   Ported from klarta-help-center.html. Nothing below adds content: with the script off,
   every device panel, both symptom sets, every code table and every archive answer is on
   screen, and each control this file drives is hidden by the sections' <noscript> rules.
   Several sections load this file; init is idempotent (every element is bound once) and
   re-runs on the theme editor's shopify:section:load. */
(function () {
  'use strict';

  var current = null; /* the device picked last; survives editor re-renders */

  function norm(s) { return s.toLowerCase().replace(/\s+/g, ' ').trim(); }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function once(el, flag) {
    if (el.hasAttribute('data-hc-' + flag)) return false;
    el.setAttribute('data-hc-' + flag, '');
    return true;
  }
  function sections() { return document.querySelectorAll('[data-hc-section]'); }
  function within(selector) {
    var out = [];
    each(sections(), function (sec) { each(sec.querySelectorAll(selector), function (el) { out.push(el); }); });
    return out;
  }

  /* --- native disclosures: mirror the open state into aria-expanded ---------
     Added here rather than in the markup so that with JS off the native
     details/summary state is the only state and can never be stale. */
  function initDetails() {
    each(within('details'), function (d) {
      var s = d.querySelector(':scope > summary');
      if (!s || !once(d, 'details')) return;
      var sync = function () { s.setAttribute('aria-expanded', String(d.open)); };
      sync();
      d.addEventListener('toggle', sync);
    });
  }

  /* --- device picker -------------------------------------------------------- */
  function showDevice(id) {
    var picks = within('#hc-picker [data-pick]');
    if (!picks.length || !id) return;
    current = id;
    picks.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-pick') === id)); });
    within('[data-dev]').forEach(function (el) {
      el.hidden = el.getAttribute('data-dev').split(/\s+/).indexOf(id) === -1;
    });
  }
  function initPicker() {
    var picks = within('#hc-picker [data-pick]');
    if (!picks.length) return;
    picks.forEach(function (b) {
      if (!once(b, 'pick')) return;
      b.addEventListener('click', function () { showDevice(b.getAttribute('data-pick')); });
    });
    var known = picks.some(function (b) { return b.getAttribute('data-pick') === current; });
    showDevice(known ? current : picks[0].getAttribute('data-pick'));
  }

  /* --- one answers panel ----------------------------------------------------- */
  function initPanel(panel) {
    if (!once(panel, 'panel')) return;
    var input = panel.querySelector('.k-search__field input');
    var clear = panel.querySelector('.hc-search__clear');
    var chips = panel.querySelectorAll('.hc-chips .k-chip');
    var title = panel.querySelector('.hc-results__title');
    var meta = panel.querySelector('.hc-results__meta');
    var empty = panel.querySelector('.hc-empty');
    var emptyT = panel.querySelector('.hc-empty__title');
    var most = parseInt(panel.getAttribute('data-most'), 10) || 6;
    var rows = [];
    each(panel.querySelectorAll('.hc-row'), function (el) {
      var q = el.querySelector('.hc-row__q'), a = el.querySelector('.k-acc__body');
      rows.push({ el: el, text: norm((q ? q.textContent : '') + ' ' + (a ? a.textContent : '')) });
    });
    var timer;

    if (input && title && meta) {
      var TITLE_DEFAULT = title.getAttribute('data-default-title');
      var TITLE_RESULTS = title.getAttribute('data-results-title');
      var META_DEFAULT = meta.getAttribute('data-default') || meta.textContent;
      var ONE = meta.getAttribute('data-one') || 'answer';
      var MANY = meta.getAttribute('data-many') || 'answers';
      var MATCHING = meta.getAttribute('data-matching') || 'matching';

      var filter = function () {
        var raw = input.value.trim(), q = norm(raw);
        if (clear) clear.hidden = !raw;
        each(chips, function (c) { c.setAttribute('aria-pressed', String(!!q && norm(c.textContent) === q)); });

        if (!q) {
          rows.forEach(function (r, i) { r.el.hidden = i >= most; r.el.open = false; });
          title.textContent = TITLE_DEFAULT;
          meta.textContent = META_DEFAULT;
          if (empty) empty.hidden = true;
          return;
        }
        var hits = 0;
        rows.forEach(function (r) {
          var m = r.text.indexOf(q) !== -1;
          r.el.hidden = !m;
          if (!m) r.el.open = false;
          if (m) hits++;
        });
        title.textContent = TITLE_RESULTS;
        meta.textContent = hits + ' ' + (hits === 1 ? ONE : MANY) + ' ' + MATCHING + ' “' + raw + '”';
        if (emptyT) emptyT.textContent = (emptyT.getAttribute('data-prefix') || '') + raw + (emptyT.getAttribute('data-suffix') || '');
        if (empty) empty.hidden = hits !== 0;
      };

      input.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(filter, 120); /* debounce, so the live region is not chatty */
      });
      input.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape') { input.value = ''; filter(); }
      });
      if (clear) clear.addEventListener('click', function () { input.value = ''; filter(); input.focus(); });
      each(chips, function (c) {
        c.addEventListener('click', function () { input.value = c.textContent.trim(); filter(); });
      });
    }

    /* browse-all disclosure */
    var browse = panel.querySelector('.hc-browse');
    var btn = panel.querySelector('.hc-browse__btn');
    if (browse && btn) {
      browse.hidden = true;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        browse.hidden = open;
        btn.textContent = btn.getAttribute(open ? 'data-label-closed' : 'data-label-open');
      });
    }
  }

  /* --- per-group truncation --------------------------------------------------- */
  function initGroups() {
    within('.hc-group[data-trunc]').forEach(function (group) {
      var btn = group.querySelector('.hc-more');
      if (!btn || !once(group, 'trunc')) return;
      group.classList.add('hc-is-trunc');
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        group.classList.toggle('hc-is-trunc', open);
        btn.textContent = btn.getAttribute(open ? 'data-label-closed' : 'data-label-open');
      });
    });
  }

  function init() {
    initDetails();
    within('[data-panel]').forEach(initPanel);
    initGroups();
    initPicker(); /* last: it hides the panels, sets and counts of the other devices */
  }

  if (window.__kHcBound) { init(); return; }
  window.__kHcBound = true;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
